<template>
  <div class="pc-competition">
    <BreadCrumb :data="breadcrumb" :title="'竞赛列表管理'" />
    <StatisticalPanel
      :whichModule="'competition'"
      :data="overallData"
    ></StatisticalPanel>
        <ModuleClassfication
      :title="titles"
      class="pc-news-tab"
      @addTopic="addTopic"
      @updateTopic="updateTopic"
      @deleteTopic="deleteTopic"
    />
    <div class="pc-competition-table">
      <NewCompetitionTable />
    </div>
  </div>
</template>
<script>
import StatisticalPanel from "../../componentSet/Statistical/StatisticalPanel.vue";
import BreadCrumb from "../../componentSet/BreadCrumb";
import ModuleClassfication from "@/components/componentSet/ModuleClassfication";
import NewCompetitionTable from "../competition/components/NewCompetitionTable";

import {
competitionCount_Api,
competitionClassification_Api,
createCompetitionClassification_Api,
updateCompetitionClassification_Api,
deleteCompetitionClassification_Api
} from "../../../apis/competition.api";
export default {
  components: {
    BreadCrumb,
    NewCompetitionTable,
    StatisticalPanel,
    ModuleClassfication,
  },
  computed: {
    breadcrumb: function () {
      return [
        { name: "首页", link: "/admin/main" },
        { name: "竞赛列表", link: "/admin/newCompetitionList" },
      ];
    },
  },
  data() {
    return {
      overallData: {
        title: "竞赛数据",
        count: [{ name: "竞赛数量", count: null }],
      },
      titles: {
        module: "竞赛",
        class: [{ name: "", subTitles: [] }],
      },
      count: 0,
    };
  },
  mounted() {
    competitionCount_Api().then((res) => {
      console.log(res.data);
      this.$set(this.overallData.count[0], "count", res.data.competition_count);
    });
    this.competitionTopicSearch()
  },
  methods: {
        updateTopic(topic, callback) {
      if (topic.type == "") {
        updateCompetitionClassification_Api({
          chinese_name: topic.chinese_name,
          english_name: topic.english_name,
          classification_id: topic.id,
          status: topic.status,
        }).then(() => {
          callback();
          this.competitionTopicSearch();
        });
      }
      
    },
    addTopic(topic, callback) {
      console.log(topic);
      if (topic.type == "") {
        createCompetitionClassification_Api({
          chinese_name: topic.chinese_name,
          english_name: topic.english_name,
          status: topic.status,
        }).then(() => {
          callback();
          this.competitionTopicSearch();
        });
      }
    },
    deleteTopic(topic, callback) {
      if (topic.type == "") {
        deleteCompetitionClassification_Api({
          classification_id: topic.id,
        }).then(() => {
          callback();
          this.competitionTopicSearch();
        });
      }
    },
    competitionTopicSearch() {
      competitionClassification_Api().then((res) => {
        this.$set(this.titles.class[0], "subTitles", res.data);
        console.log(this.titles);
        console.log(res.data);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/competition/NewCompetitionList.vue